<template lang="pug">
.product-information
  CardMinimal(:title="$t('products.product_information')")
    .p-a-4.information(:class="`${error ? 'error' : ''}`")
      p.m-b-1 {{ $t('common.title').toUpperCase() }}
      FormInput(type="text", v-model="data.name").f-w
      p.m-t-4.m-b-1 {{ $t('products.detailed_description').toUpperCase() }}
      FormTextarea(:toolbar="['bold', 'ul', 'link']", v-model="data.description", height="160" v-if="isMounted").small
</template>

<script>

export default {
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    /**
     * Will be run by the parent when updating data
     */
    async update() {
      const { changed, data: { name, description } } = this;

      if (!changed) {
        return;
      }

      await this.$store.dispatch('Products/updateProduct', {
        id: this.editData.id,
        payload: {
          name,
          description,
        }
      });
    },
    async validate() {
      this.error = false;

      if (this.data.name === '') {
        this.error = true;
        return false;
      }

      return true;
    },
  },
  watch: {
    data: {
      deep: true,
      /**
       * Listen for changes on data and emit them to parent
       * @param {Object} data
       */
      handler(data) {
        if (this.isMounted) {
          this.changed = true;
          this.$emit('data', data);
        }
      },
    },
  },
  data() {
    return {
      isMounted: false,
      changed: false,
      error: false,
      data: {
        name: '',
        description: '',
      },
    };
  },
  mounted() {
    if (this.editData && this.edit) {
      const {
        name = '',
        description = '',
      } = this.editData;

      this.data = {
        name,
        description,
      };
    }

    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.information {
  &.error {
    background-color: rgba(#D0021B, .2);
    border-radius: 10px;
  }
}
</style>